// This function return True if the input value is null/undefined (or) false if it contains any value. 
export default function isNullOrUndefined(value) {
    return (value === undefined || value === null);
}